import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {shareReplay, switchMap, tap} from "rxjs/operators";
import {ActionBusinessRules} from "./action-business-rules";
import {ApiRouteConfig} from "../../../../config/api.route.config";

@Injectable()
export class ActionBusinessRulesService {
  private rules: ActionBusinessRules = null;
  public readonly rules$ = of(this.rules).pipe(
      switchMap(rules => rules ? of(rules) : this.fetchActionBusinessRules())
  );
  constructor(
      private readonly httpClient: HttpClient,
      private readonly api: ApiRouteConfig,
  ) { }

  private fetchActionBusinessRules() {
    return this.httpClient.get<ActionBusinessRules>(this.api.ACTION_BUSINESS_RULES).pipe(
        tap(rules => this.rules = rules),
        shareReplay({refCount: true, bufferSize: 1})
    );
  }
}
